/* Pamo mobile rails v1.1.0. Native touch scrolling; no touchstart/touchmove interception.
   Mouse dragging affects ONLY these tracks. No global cart, quote or wholesale handlers. */
(() => {
  'use strict';
  const tag = 'pamo-home-rail';
  if (!window.customElements || customElements.get(tag)) return;
  class PamoHomeRail extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._track = this.querySelector('[data-pd-track]');
      if (!this._track) {
        if (!this._wait) { this._wait = new MutationObserver(() => this.connectedCallback()); this._wait.observe(this, { childList: true, subtree: true }); }
        return;
      }
      this._wait?.disconnect(); this._wait = null;
      this._on = true;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      const track = this._track;
      const update = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => { this._raf = 0; this._update(); });
      };
      track.addEventListener('scroll', update, { passive: true, signal });
      this.addEventListener('click', event => {
        const button = event.target instanceof Element ? event.target.closest('[data-pd-dir]') : null;
        if (!button || !this.contains(button) || button.disabled) return;
        const child = [...track.children].find(el => !el.hidden);
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const step = child ? child.getBoundingClientRect().width + gap : track.clientWidth * .8;
        const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
        track.scrollBy({ left: Number(button.dataset.pdDir) * step * rtl,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, { signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const button = this.querySelector(`[data-pd-dir="${event.key === 'ArrowLeft' ? -1 : 1}"]`);
        if (button && !button.disabled) { event.preventDefault(); button.click(); }
      }, { signal });
      track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || track.scrollWidth <= track.clientWidth + 2) return;
        if (!(event.target instanceof Element) || event.target.closest('button,input,select,textarea,label,summary,[contenteditable="true"]')) return;
        this._drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, moved: false };
      }, { signal });
      track.addEventListener('pointermove', event => {
        const drag = this._drag;
        if (!drag || drag.id !== event.pointerId || event.pointerType !== 'mouse') return;
        const dx = event.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(event.clientY - drag.y) > 12 && Math.abs(dx) < 8) { this._drag = null; return; }
          if (Math.abs(dx) < 8) return;
          drag.moved = true; track.classList.add('pd-dragging');
          try { track.setPointerCapture(event.pointerId); } catch (_) {}
        }
        event.preventDefault(); track.scrollLeft = drag.left - dx;
      }, { signal });
      const finish = event => {
        const drag = this._drag; if (!drag || (event.pointerId !== undefined && event.pointerId !== drag.id)) return;
        if (drag.moved) this._suppressClickUntil = performance.now() + 300;
        this._drag = null; track.classList.remove('pd-dragging');
        try { if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id); } catch (_) {}
        update();
      };
      track.addEventListener('pointerup', finish, { signal });
      track.addEventListener('pointercancel', finish, { signal });
      track.addEventListener('lostpointercapture', finish, { signal });
      track.addEventListener('pointerleave', event => { if (this._drag && !this._drag.moved) finish(event); }, { signal });
      track.addEventListener('click', event => {
        if (event.detail !== 0 && performance.now() < (this._suppressClickUntil || 0)) {
          event.preventDefault(); event.stopImmediatePropagation(); this._suppressClickUntil = 0;
        }
      }, { capture: true, signal });
      if (window.ResizeObserver) {
        this._resize = new ResizeObserver(update); this._resize.observe(track);
      } else window.addEventListener('resize', update, { passive: true, signal });
      this._mutation = new MutationObserver(update);
      this._mutation.observe(track, { childList: true });
      this.addEventListener('load', update, { capture: true, signal });
      update();
    }
    _update() {
      if (!this.isConnected || !this._track) return;
      const track = this._track; const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const tools = this.querySelector('[data-pd-tools]'); if (tools) tools.hidden = max < 3;
      const current = Math.abs(track.scrollLeft);
      this.querySelectorAll('[data-pd-dir="-1"]').forEach(b => { b.disabled = current < 3; });
      this.querySelectorAll('[data-pd-dir="1"]').forEach(b => { b.disabled = current >= max - 3; });
      const position = this.querySelector('[data-pd-position]');
      if (position && track.children.length) {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const stride = track.children[0].getBoundingClientRect().width + gap;
        position.textContent = `· ${Math.min(track.children.length, Math.round(current / Math.max(1,stride)) + 1)} de ${track.children.length}`;
      }
    }
    disconnectedCallback() {
      this._abort?.abort(); this._resize?.disconnect(); this._mutation?.disconnect(); this._wait?.disconnect(); this._wait = null;
      if (this._raf) cancelAnimationFrame(this._raf);
      this._track?.classList.remove('pd-dragging'); this._drag = null; this._raf = 0; this._on = false;
    }
  }
  customElements.define(tag, PamoHomeRail);
})();
